/**
 * @file Automatically generated by barrelsby.
 */

export * from './release-note-popup.component';
